import { ContentKind } from 'models/socialCampaign'
import { ProductKind } from 'constants/product'

/** How the section draws a kind of content and how a client can get more of it (prototype v3 `CONTENT`). */
export interface ContentKindWays {
  /** The product whose glyph `ProductIcon` draws for the kind */
  icon: ProductKind
  /** "Create with AI" in its Add menu: the reel (ISSUE-3635), the staging (ISSUE-3634), the floor plan (ISSUE-3989) */
  createWithAi: boolean
  /** A "New" badge on the kind and on its Create with AI: the AI-made reel and floor plan */
  isNew: boolean
  /** "Upload" in its Add menu; never for staging, which is made, not shot */
  upload: boolean
}

export const CONTENT_KIND_WAYS: Record<ContentKind, ContentKindWays> = {
  [ContentKind.PHOTOS]: { icon: ProductKind.GROUND_PHOTO, createWithAi: false, isNew: false, upload: true },
  [ContentKind.VIDEOS]: { icon: ProductKind.REEL_VIDEO, createWithAi: true, isNew: true, upload: true },
  [ContentKind.VIRTUAL_STAGING]: { icon: ProductKind.RESIDENTIAL_STAGING, createWithAi: true, isNew: false, upload: false },
  [ContentKind.FLOOR_PLANS]: { icon: ProductKind.FLOOR_PLAN_EDITING_2D, createWithAi: true, isNew: true, upload: true },
  [ContentKind.DRONE]: { icon: ProductKind.DRONE_PHOTO, createWithAi: false, isNew: false, upload: true },
}

/** What a missing kind is going through, once the AI creation (ISSUE-3634/3635/3989) or the order (ISSUE-3987) is wired. */
export type ContentKindProgress =
  /** An AI creation is running: a spinner, "you can keep working" */
  | { state: 'creating' }
  /** Ordered: "Arrives <delivery> · N posts reserved" and an Ordered badge; `delivery` is a day, YYYY-MM-DD */
  | { state: 'ordered', delivery: string, reservedPosts: number }
